export const config = {
    aplicacao: 'CriaService',
    version: '1.0.0',
    build: ''
  };
